import { z } from 'zod';

/**
 * Standard paginated-list envelope returned by (nearly) every list endpoint
 * (the many `Paginated*` schemas in the OpenAPI spec.
 *
 * Wrap a domain item schema with this instead of redeclaring the same
 * four-field envelope in every domain: `zodPaginatedResponseSchema(zodFooSchema)`.
 */
export const zodPaginatedResponseSchema = <ItemSchema extends z.ZodType>(
  itemSchema: ItemSchema,
) =>
  z.object({
    data: z.array(itemSchema),
    hasNextPage: z.boolean(),
    paginatedCount: z.number().int().nonnegative(),
    totalCount: z.number().int().nonnegative().nullish(),
  });
